var MuiListItemText = {
    /* put your new default props here */
    primaryTypographyProps: {
        variant: 'h6',
    },
    secondaryTypographyProps: {
        variant: 'body1',
    },
};
export default MuiListItemText;
//# sourceMappingURL=MuiListItemText.js.map